import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";

const VolumeOscillatorFields = ({
  values,
  handleVolumeOscillatorValues,
}) => {
  const [shortPeriod, setShortPeriod] = useState(values.short_ndays || 14);
  const [longPeriod, setLongPeriod] = useState(values.long_ndays || 28);

  useEffect(() => {
    handleVolumeOscillatorValues(shortPeriod, longPeriod);
  }, [shortPeriod, longPeriod]);

  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <TextField
        label="Short Period"
        size="small"
        value={shortPeriod}
        onChange={(e) => setShortPeriod(e.target.value)}
        sx={{ width: 120 }}
      />
      <TextField
        label="Long Period"
        size="small"
        value={longPeriod}
        onChange={(e) => setLongPeriod(e.target.value)}
        sx={{ width: 120 }}
      />
    </div>
  );
};

export default VolumeOscillatorFields;
